import "./AboutUs.module.css";
import MainHeader from "@/reusable_sections/Header";
import VisionYCompromiso from "./sections/VisionYCompromiso";
import MilestonesOfIntegrity from "./sections/MilestonesOfIntegrity";
import StrategicAlliances from "./sections/StrategicAlliances";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <MainHeader />
      <VisionYCompromiso />
      <MilestonesOfIntegrity />
      <StrategicAlliances />
      <Footer />
    </div>;
}